export default __webpack_public_path__ + "static/media/Eina01-Bold.f157080e.woff";